import React from "react";
import styles from "../css/Equipment.css";
// import styles from "../css/App.css";
import { Toast } from "antd-mobile";
import { request, origin } from "../request";
import { Header } from "./Introduce";

function Item({ item, key }) {
  const display = [29,12,30,31]
  console.log(display.indexOf(item.id))
  if (display.indexOf(item.id) !==-1) {
    return (
      <div className={styles.Item} key={key}>
        <div className={styles.imgBorder}>
          <img
            src={origin + item.cover_image}
            alt=""
            className={styles.leftImg}
          ></img>
        </div>

        <div className={styles.name}>
          <span
            className={styles.title}
            style={{ WebkitBoxOrient: "vertical" }}
          >
            {item.name}
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.Item} key={key}>

        <a
          href={"#/EquipmentDetail/" + item.id}
        >
          <div className={styles.imgBorder}>
            <img
              src={origin + item.cover_image}
              alt=""
              className={styles.leftImg}
            ></img>
          </div>

          <div className={styles.name}>
            <span
              className={styles.title}
              style={{ WebkitBoxOrient: "vertical" }}
            >
              {item.name}
            </span>
          </div>
        </a>
      </div>
    );
  }


}

class Equipment extends React.Component {
  state = {
    data: [],
    imgHeight: 176,
  };
  componentDidMount() {
    const type = this.props.match.params.type
    request("index/getEquipmentList", {type:type}, ({ data }) => {
      if (data.code === 1) {
        this.setState({
          data: data.data,
        });
      } else {
        Toast.fail("获取设备失败");
      }
    });
  }
  render() {
    return (
      <div>
        <Header text="仪器设备"></Header>

        <div className={styles.main}>
          {this.state.data.map((val) => (
            <Item item={val} key={val.id}></Item>
          ))}
        </div>
      </div>
    );
  }
}

// Equipment.propTypes = {
//   name: "123456",
// };

export default Equipment;



// WEBPACK FOOTER //
// ./src/pages/Equipment.js